import { addSubCategory } from '../../../actions/siteadmin/SubCategory/addSubCategory';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {

	const isRestrict = await dispatch(demoRestriction({ restrictType: 'subCategory', restrictValue: values?.id }));
	if (isRestrict) return;

	if (!values.image) {
		showToaster({ messageId: 'subCategoryImage', toasterType: 'error' });
		return;
	}

	await dispatch(
		addSubCategory(
			values.id,
			values.name,
			values.description,
			values.image,
			values.categoryId,
			values.status
		)
	)
}

export default submit;